import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

export type SparkSpreadProduct = "SpSp Base (5/2)" | "SpSp Peak (1/1)";

interface SparkSpreadProductSelectProps {
  selectedSpread: SparkSpreadProduct;
  setSelectedSpread: React.Dispatch<React.SetStateAction<SparkSpreadProduct>>;
}

export function SparkSpreadProductSelect(props: SparkSpreadProductSelectProps) {
  const { t } = useTranslation();
  return (
    <Select
      onValueChange={(value) => props.setSelectedSpread(value as SparkSpreadProduct)}
      defaultValue={props.selectedSpread}
    >
      <SelectTrigger>
        <SelectValue placeholder={t("Select a spread")} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          <SelectLabel>{t("Sparkspread Products")}</SelectLabel>
          <SelectItem value="SpSp Base (5/2)">SpSp Base (5/2)</SelectItem>
          <SelectItem value="SpSp Peak (1/1)">SpSp Peak (1/1)</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
